// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checker-container[data-v-362e4c38]{display:flex;justify-content:flex-end}.checker-container a[data-v-362e4c38]{text-decoration:none;color:#e72510;display:inline-block;padding:0 .8rem;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
